"use client";

import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Landscaping() {
  const intro = useRevealOnScroll<HTMLDivElement>();
  const cards = useRevealOnScroll<HTMLDivElement>();
  const departments = [{
    eyebrow: "01",
    name: "Full diagnostics and repair",
    problem: "We identify the problem quickly and fix it right, getting your mower back in working order as soon as possible.",
    outcomes: [],
    href: "/LawnMowerServicingRepairsInCarlisleCumbriaPage"
  }, {
    eyebrow: "02",
    name: "Blade sharpening and replacement",
    problem: "Dull blades tear rather than cut, leaving your lawn looking ragged. We'll sharpen or replace them for a clean, healthy finish.",
    outcomes: [],
    href: "/LawnMowerServicingRepairsInCarlisleCumbriaPage"
  }, {
    eyebrow: "03",
    name: "Engine servicing and tuning",
    problem: "We service and tune your engine to restore full performance and extend the life of your machine.",
    outcomes: [],
    href: "/RideOnMowerServicingRepairsPage"
  }, {
    eyebrow: "04",
    name: "Carburettor cleaning and adjustment (petrol models)",
    problem: "A dirty or misadjusted carburettor is one of the most common causes of poor running. We clean and set it correctly so your engine runs smoothly.",
    outcomes: [],
    href: "/RideOnMowerServicingRepairsPage"
  }, {
    eyebrow: "05",
    name: "Oil change and general maintenance",
    problem: "Fresh oil and a thorough check-over keeps your mower running reliably season after season.",
    outcomes: [],
    href: "#"
  }, {
    eyebrow: "06",
    name: "Drive system and wheel repairs",
    problem: "Problems with self-propelled drive or wheels? We diagnose and repair mechanical faults to restore full control.",
    outcomes: [],
    href: "#"
  }, {
    eyebrow: "07",
    name: "Battery and electrical system checks",
    problem: "We test batteries, charging systems, and electrical connections to ensure everything is working as it should.",
    outcomes: [],
    href: "#"
  }, {
    eyebrow: "08",
    name: "Complete seasonal servicing",
    problem: "Our full seasonal service covers everything your mower needs before the cutting season begins — or at the end of it.",
    outcomes: [],
    href: "#"
  }];
  return <section data-section-id="18605" id="lawnmowerservices" className="bg-background border-t-[1.5px] border-border py-24 md:py-32">
      <div className="mx-auto max-w-[1320px] px-5 sm:px-8 lg:px-14">
        <div className="flex flex-col items-center">
          
          <div className="w-full text-center mb-16">
            <div ref={intro.ref} className={`transition-all duration-[480ms] ease-[cubic-bezier(0.2,0.8,0.2,1)] ${intro.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
              
              <h2 className="font-default text-foreground leading-[1.02] mb-8" style={{
              fontSize: "clamp(2rem, 4.2vw, 3.75rem)",
              letterSpacing: "-0.03em"
            }}>
                <span className="font-extrabold">Lawn Mower Services</span>
              </h2>
              <p className="font-default text-muted-foreground leading-[1.55] mx-auto max-w-2xl" style={{
              fontSize: "clamp(1.0625rem, 1.15vw, 1.25rem)",
              letterSpacing: "-0.005em"
            }}>
                Our services include:
              </p>
            </div>
          </div>

          
          <div ref={cards.ref} className="w-full max-w-[900px]">
            <div className="flex flex-col">
              {departments.map((dept, i) => <article key={dept.name} data-index={i} style={{
              transitionDelay: `${i * 80}ms`,
              marginTop: i === 0 ? 0 : "-1.5px"
            }} className={`group relative bg-card border-[1.5px] border-border p-9 md:p-11 transition-all duration-[480ms] ease-[cubic-bezier(0.2,0.8,0.2,1)] hover:border-primary hover:py-[2.75rem] md:hover:py-[3.5rem] hover:relative hover:z-10 ${cards.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
                  <div className="flex flex-col gap-6">
                    <div className="flex items-start justify-between gap-4">
                      <p className="font-mono text-xs font-medium uppercase tracking-[0.12em] text-muted-foreground">
                        {dept.eyebrow}
                      </p>
                    </div>

                    <h3 className="font-default font-bold text-foreground" style={{
                  fontSize: "clamp(1.75rem, 2.6vw, 2.25rem)",
                  letterSpacing: "-0.025em",
                  lineHeight: "1.05"
                }}>
                      {dept.name}
                    </h3>

                    <p className="font-default text-foreground/85 leading-[1.5]" style={{
                  fontSize: "clamp(1rem, 1.05vw, 1.125rem)"
                }}>
                      {dept.problem}
                    </p>

                    {dept.outcomes.length > 0 && <ul className="flex flex-col gap-3 mt-2">
                        {dept.outcomes.map((outcome, j) => <li data-index={j} key={j} className="flex items-start gap-3 font-default text-foreground text-base leading-[1.55]">
                            <span className="mt-2 inline-block size-2 shrink-0 bg-primary" aria-hidden="true" />
                            <span>{outcome}</span>
                          </li>)}
                      </ul>}

                    <div className="flex justify-end mt-2">
                      <Link to={dept.href} className="inline-flex items-center gap-2 font-default font-semibold text-sm text-primary underline underline-offset-[6px] decoration-[1.5px] hover:decoration-[2.5px] transition-all duration-200">
                        
                        
                      </Link>
                    </div>
                  </div>
                </article>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}